import React from 'react';
import * as stylex from '@stylexjs/stylex';
import { Toaster } from "react-hot-toast";
import { useIAppContext } from "nood-comp/src/context-providers/IAppContextProvider";
export default function ToasterWrapper(props) {
  var _useIAppContext;
  var isDarkMode = ((_useIAppContext = useIAppContext()) === null || _useIAppContext === void 0 ? void 0 : _useIAppContext.lightOrDark) === 'dark';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Toaster, {
    toastOptions: {
      position: 'bottom-center',
      style: {
        backgroundColor: isDarkMode ? '#fefefe' : '#524c5b',
        color: isDarkMode ? '#333' : '#fefefe'
      }
    }
  }));
}

// @ts-ignore